import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { strings, getCurrentLocale } from '../../localization';
import Events from '../common/events';

export default class NotFoundPage extends Component {

    componentDidMount() {
        console.error("Not Found Page loaded", window.location);

        // Just in case we got here by blocking access to a route with loading overlay, hide the loading page
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    render() {

        return (
            <div className="container page-container page-error">
                <h1>{strings.formatString(strings.app_oops)}</h1>
                <hr />
                <p>{strings.formatString(strings.not_found_m1)}</p>
                <p>{strings.formatString(strings.not_found_m2, <NavLink to={"/" + getCurrentLocale() + "/dashboard"}>{strings.formatString(strings.click_here)}</NavLink>)}</p>
            </div>
        );
    }
}